var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1959_990)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49988 3.49932V3.48577V2.75C1.49988 2.61193 1.61181 2.5 1.74988 2.5H14.2499C14.388 2.5 14.4999 2.61193 14.4999 2.75V3.48594V3.49578V3.50277V3.51265V13.25C14.4999 13.3881 14.388 13.5 14.2499 13.5H1.74988C1.61181 13.5 1.49988 13.3881 1.49988 13.25V3.51282V3.49932ZM1.74988 1C0.78338 1 -0.000122066 1.7835 -0.000122066 2.75V3.48577C-0.000285027 3.49479 -0.000284637 3.50381 -0.000122066 3.51282V13.25C-0.000122066 14.2165 0.783379 15 1.74988 15H14.2499C15.2164 15 15.9999 14.2165 15.9999 13.25V3.51265C16.0001 3.50376 16.0001 3.49485 15.9999 3.48594V2.75C15.9999 1.7835 15.2164 1 14.2499 1H1.74988ZM4.13518 5.59202C3.77938 5.37993 3.31902 5.49641 3.10692 5.8522C2.89482 6.20799 3.01131 6.66836 3.3671 6.88046L7.61537 9.41299C7.85196 9.55403 8.14682 9.55403 8.38341 9.41301L12.6314 6.88094C12.9872 6.66886 13.1037 6.2085 12.8916 5.8527C12.6796 5.4969 12.2192 5.38039 11.8634 5.59247L7.99943 7.89563L4.13518 5.59202Z",
    fill: "#176DEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1959_990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.b6b9249895ed7a825dbc23b37a13ce59.svg";
export { ForwardRef as ReactComponent };